import React, { Component } from 'react';
import styled from 'styled-components';
import moment from 'moment';

const CopyRight = styled.div.withConfig({ componentId: 'sc-mm3w8n-0' })`
  margin-top: 5px;
  text-align: left;
`;

class Copyright extends Component {
  render() {
    return <CopyRight>{moment().format('YYYY')} © SolvHealth. All Rights Reserved</CopyRight>;
  }
}

export default Copyright;
